export const dashboardConstants = {
  GET_GENERAL_REPORT_REQUEST: "BANNER_GET_GENERAL_REPORT_REQUEST",
  GET_GENERAL_REPORT_SUCCESS: "BANNER_GET_GENERAL_REPORT_SUCCESS",
  GET_GENERAL_REPORT_FAILURE: "BANNER_GET_GENERAL_REPORT_FAILURE",

  GET_TIMELY_REPORT_REQUEST: "BANNER_GET_TIMELY_REPORT_REQUEST",
  GET_TIMELY_REPORT_SUCCESS: "BANNER_GET_TIMELY_REPORT_SUCCESS",
  GET_TIMELY_REPORT_FAILURE: "BANNER_GET_TIMELY_REPORT_FAILURE",
};
